import { Button } from "@repo/ui";
import { useNavigate } from "react-router-dom";

export function Home() {
  const navigate = useNavigate();

  return (
    <div className="">
      {/* Hero */}
      <section className="relative">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1503377980938-b9f15e5f73f6?q=80&w=1920&auto=format&fit=crop"
            alt="Glamping tents at sunrise in nature"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background/80 to-background/20" />
        </div>
        <div className="relative max-w-6xl mx-auto px-4 py-24 md:py-36">
          <h1 className="text-4xl md:text-5xl font-semibold tracking-tight">
            Nature‑immersed glamping in Suan Pueng
          </h1>
          <p className="mt-3 text-lg text-foreground/80 max-w-2xl">
            Wake to birdsong, sleep under the stars. Cozy tents with hotel‑level comfort.
          </p>
          <div className="mt-6 flex gap-3">
            <Button
              onClick={() => navigate("/booking")}
              className="bg-primary text-primary-foreground"
            >
              Book Now
            </Button>
            <Button onClick={() => navigate("/accommodation")} variant="outline">
              See Tents
            </Button>
          </div>
        </div>
      </section>

      {/* Quick availability */}
      <section className="max-w-6xl mx-auto px-4 -mt-10 relative z-10">
        <div className="bg-card border rounded-xl p-4 md:p-6 shadow-sm/5">
          <div className="grid md:grid-cols-4 gap-3">
            <input
              type="date"
              className="h-10 rounded-md border bg-background px-3 text-sm"
              aria-label="Check-in"
            />
            <input
              type="date"
              className="h-10 rounded-md border bg-background px-3 text-sm"
              aria-label="Check-out"
            />
            <select
              className="h-10 rounded-md border bg-background px-3 text-sm"
              aria-label="Tent type"
            >
              <option>Any tent</option>
              <option>King Bed Tent</option>
              <option>Double‑Queen Tent</option>
            </select>
            <Button onClick={() => navigate("/booking")}>Search</Button>
          </div>
        </div>
      </section>

      {/* Amenities */}
      <section className="max-w-6xl mx-auto px-4 py-12">
        <h2 className="text-xl font-semibold">Top amenities</h2>
        <div className="mt-4 grid grid-cols-2 md:grid-cols-4 gap-4 text-sm text-foreground/80">
          <div className="p-4 bg-muted rounded-lg">Private bathroom</div>
          <div className="p-4 bg-muted rounded-lg">A/C</div>
          <div className="p-4 bg-muted rounded-lg">Wi‑Fi</div>
          <div className="p-4 bg-muted rounded-lg">Free parking</div>
        </div>
      </section>

      {/* Highlights */}
      <section className="max-w-6xl mx-auto px-4 pb-12">
        <div className="grid md:grid-cols-3 gap-6">
          {["Sunrise views", "Starry nights", "Quiet, fresh air"].map((h) => (
            <div key={h} className="p-6 rounded-xl border bg-card">
              {h}
            </div>
          ))}
        </div>
      </section>

      {/* Map preview */}
      <section className="max-w-6xl mx-auto px-4 pb-16">
        <h2 className="text-xl font-semibold mb-3">Where we are</h2>
        <div className="aspect-[16/9] rounded-lg overflow-hidden border bg-muted">
          <iframe
            title="Map"
            className="w-full h-full"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            src="https://www.google.com/maps?q=Suan%20Phueng%2C%20Ratchaburi&output=embed"
          />
        </div>
      </section>
    </div>
  );
}
